'use strict';

var CallFieldsExtension = require('./CallFieldsExtension');
require('./CallsService');
var defaults = require('../../defaults/Defaults');
require('./KayleeService');
var log = require('../../log/Log').channel('RecentsController');
var moment = require('moment');
require('./RoomService');
var TooltipExtension = require('./TooltipExtension').default;

angular.module('inara').controller('RecentsController', RecentsController);

RecentsController.$inject = [
    '$scope',
    '$timeout',
    '$ionicScrollDelegate',
    '$ionicPopover',
    'ionicMaterialInk',
    'KayleeService',
    'RoomService',
    'CallsService',
    '$ionicViewSwitcher',
    'gettextCatalog',
];

function RecentsController(
    $scope,
    $timeout,
    $ionicScrollDelegate,
    $ionicPopover,
    ionicMaterialInk,
    KayleeService,
    RoomService,
    CallsService,
    $ionicViewSwitcher,
    gettextCatalog
) {
    var vm = this;
    var lastScrollTop = 0;

    log.info('initializing');

    angular.extend(vm, new CallFieldsExtension());
    angular.extend(vm, new TooltipExtension($scope, $ionicPopover));

    ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });

    vm.getRecentCalls = function () {
        return CallsService.getRecentCalls();
    };
    vm.formatDate = formatDate;
    vm.formatTime = formatTime;
    vm.getMeetingCodesLabel = getMeetingCodesLabel;
    vm.selectedCall = null;
    vm.dialCall = dialCall;
    vm.isAudioCall = isAudioCall;
    vm.isVideoCall = isVideoCall;
    vm.isPlacedCall = isPlacedCall;
    vm.isReceivedCall = isReceivedCall;
    vm.isMissedCall = isMissedCall;
    vm.hasNoContactPicture = hasNoContactPicture;
    vm.canCallType = CallsService.canCallType;
    vm.onScroll = onScroll;

    $scope.$on('$stateChangeSuccess', onStateChange);
    $scope.onFirst = function () {
        ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });
    };
    $scope.onLast = function () {
        ionicMaterialInk.displayEffect({ duration: defaults.inara.inkDuration });
    };

    $scope.$on('$ionicView.enter', function () {
        vm.recentCalls = vm.getRecentCalls();
    });

    function onStateChange(event, toState, toParams, fromState, fromParams) {
        if (toState.name !== 'control.recents') {
            vm.selectedCall = null;
            vm.tooltip.hide();
        } else {
            $ionicScrollDelegate.scrollTop(false);
        }
    }

    function formatDate(ms) {
        var room = RoomService.getRoom();

        if (typeof ms === 'undefined' || ms === null || room === null) {
            /// Value for displaying an unknown date
            return gettextCatalog.getString('Unknown');
        }

        var site = KayleeService.getSite(room.siteId);
        if (!site.$isLoaded()) return '';

        var timeZone = site.settings.timeZone;
        var callMoment = moment(ms).tz(timeZone);
        var todayMidnight = moment().tz(timeZone).startOf('day');
        var yesterdayMidnight = moment(todayMidnight).subtract(1, 'days');

        if (callMoment.isAfter(todayMidnight)) {
            /// Recent calls placeholder for today's date
            return gettextCatalog.getString('Today');
        } else if (callMoment.isBefore(todayMidnight) && callMoment.isAfter(yesterdayMidnight)) {
            /// Recent calls placeholder for yesterday's date
            return gettextCatalog.getString('Yesterday');
        } else {
            return callMoment.format('l');
        }
    }

    function formatTime(ms) {
        var room = RoomService.getRoom();

        if (typeof ms === 'undefined' || ms === null || room === null) {
            /// Value for displaying an unknown time
            return gettextCatalog.getString('Unknown');
        }

        var site = KayleeService.getSite(room.siteId);
        if (!site.$isLoaded()) return '';

        var timeZone = site.settings.timeZone;
        var callMoment = moment(ms).tz(timeZone);
        return callMoment.format(site.settings.timeFormat);
    }

    function getMeetingCodesLabel(call) {
        if (angular.isDefined(call) && call.hasOwnProperty('meetingCodes')) {
            return gettextCatalog.getString('Meeting codes: {{meetingCodes}}', {
                meetingCodes: vm.callfields.getMeetingCodes(call),
            });
        }

        return '';
    }

    function dialCall(call, $event) {
        if (!CallsService.canCallType(call.callType)) {
            vm.tooltip.show(CallsService.getExceededMaxCallsStringByType(call.callType), $event);
            return;
        }

        vm.selectedCall = null;
        var number = /((?:sip:)?[\da-zA-Z@#.]+)/;
        var match = null;
        var dialString = null;

        // When dialing, use the following, in order of preference.
        // 1. For voip or video calls, a group of digits, '.', '@', and '#' in the dialString.
        // 2. For voip or video calls, a group of digits, '.', '@', and '#' in the contactName.
        // 3. For all calls, the dialString, if it isn't empty.
        // 4. For all calls, the contactName, if it isn't empty.

        if (call.callType === 'voip' || call.callType === 'video') {
            if (angular.isDefined(call.dialString)) {
                match = number.exec(call.dialString);
                if (match !== null) {
                    dialString = match[1];
                }
            }
            if (match === null && angular.isDefined(call.contactName)) {
                match = number.exec(call.contactName);
                if (match !== null) {
                    dialString = match[1];
                }
            }
        }

        if (dialString === null) {
            if (angular.isDefined(call.dialString)) {
                dialString = call.dialString;
            } else if (angular.isDefined(call.contactName)) {
                dialString = call.contactName;
            }
        }

        if (dialString !== null) {
            var callMethod = {
                callType: call.callType,
                dialString: dialString,
            };
            if (angular.isDefined(call.contactName)) {
                callMethod.contactName = call.contactName;
            }
            if (angular.isDefined(call.displayDialString)) {
                callMethod.displayDialString = call.displayDialString;
            }
            if (angular.isDefined(call.meetingCodes)) {
                callMethod.meetingCodes = call.meetingCodes;
            }
            $ionicViewSwitcher.nextDirection('forward');
            CallsService.placeCallByType(callMethod);
        }
    }

    function isAudioCall(call) {
        return (
            angular.isDefined(call.callType) &&
            KayleeService.getCallClass(call.callType) === 'audio'
        );
    }

    function isVideoCall(call) {
        return (
            angular.isDefined(call.callType) &&
            KayleeService.getCallClass(call.callType) === 'video'
        );
    }

    function isPlacedCall(call) {
        return !angular.isDefined(call.direction) || call.direction === 'outgoing';
    }

    function isReceivedCall(call) {
        return call.direction === 'incoming';
    }

    function isMissedCall(call) {
        return angular.isDefined(call.missed) && call.missed;
    }

    function hasNoContactPicture(call) {
        return true;
    }

    function onScroll() {
        var newScrollTop = $ionicScrollDelegate
            .$getByHandle('recent-calls-scroll')
            .getScrollPosition().top;
        if (newScrollTop !== lastScrollTop) {
            lastScrollTop = newScrollTop;
            vm.selectedCall = null;
        }
    }
}

module.exports = RecentsController;
